module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-Italic.9d20e066.woff";